import { GenericTableColumn } from 'shared/components/thunderbolt/IWGenericTable'
import { Column } from 'shared/components/thunderbolt/IWTable'
import { LsSchedulingType } from './types'

const defaultTableSchema: GenericTableColumn[] = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Location Name',
    accessor: 'locationName',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Submitted Date',
    accessor: 'createdAt',
    align: 'left',
    minWidth: 300,
  },
  {
    title: 'Date',
    accessor: 'date',
    align: 'left',
    minWidth: 125,
    filterType: 'string',
  },
  {
    title: 'Schedule Type',
    accessor: 'schedulingType',
    align: 'left',
    minWidth: 30,
  },
  {
    title: 'Contract Name',
    accessor: 'contractName',
    align: 'left',
  },
  {
    title: 'Submitted By',
    accessor: 'submittedBy',
    align: 'left',
    minWidth: 300,
  },
  {
    title: 'Status',
    accessor: 'submitStatus',
    align: 'left',
    filterType: 'string',
  },
  {
    title: 'Message',
    accessor: 'message',
    align: 'left',
    minWidth: 400,
  },
  {
    title: 'Submission ID',
    accessor: 'submissionId',
    align: 'left',
    minWidth: 401,
  },
  ...Array.from({ length: 24 }, (_, i) => ({
    title: `${i + 1}`,
    accessor: `${i + 1}`,
    align: 'right',
  })),
]

export function getDayAheadBidsConvertSchema(): Column[] {
  return [
    {
      title: 'brand',
      accessor: 'brand',
      align: 'left',
      pinnable: true,
      sticky: 'left',
    },
    {
      title: 'market',
      accessor: 'market',
      align: 'left',
    },
    {
      title: 'zone',
      accessor: 'zone',
      align: 'left',
    },
    {
      title: 'location',
      accessor: 'location',
      align: 'left',
    },
    {
      title: 'location name',
      accessor: 'location_name',
      align: 'left',
    },
    {
      title: 'date',
      accessor: 'date',
      align: 'right',
    },
    ...Array.from({ length: 24 }, (_, i) => ({
      title: `${i + 1}`,
      accessor: `${i + 1}`,
      align: 'right',
    })),
  ]
}

export function getInternalBilateralTableSchema(): Column[] {
  return [
    {
      title: 'contract id',
      accessor: 'contract_id',
      align: 'left',
    },
    {
      title: 'Contract Name',
      accessor: 'contract_name',
      align: 'left',
      minWidth: 200,
    },
    {
      title: 'market',
      accessor: 'market',
      align: 'left',
    },
    {
      title: 'brand',
      accessor: 'brand',
      align: 'left',
      pinnable: true,
      sticky: 'left',
    },
    {
      title: 'zone',
      accessor: 'zone',
      align: 'left',
    },
    {
      title: 'date',
      accessor: 'date',
      align: 'left',
      minWidth: 125,
    },
    {
      title: 'buyer',
      accessor: 'buyer',
      align: 'left',
      minWidth: 200,
    },
    {
      title: 'Buyer QSE Code',
      accessor: 'buyer_qse_code',
      align: 'left',
    },
    {
      title: 'seller',
      accessor: 'seller',
      align: 'left',
      minWidth: 200,
    },
    {
      title: 'Seller QSE Code',
      accessor: 'seller_qse_code',
      align: 'left',
    },
    ...Array.from({ length: 24 }, (_, i) => ({
      title: `${i + 1}`,
      accessor: `${i + 1}`,
      align: 'right',
    })),
  ]
}

const ercotTableSchema: GenericTableColumn[] = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Location Name',
    accessor: 'locationName',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Submitted Date',
    accessor: 'createdAt',
    align: 'left',
    minWidth: 300,
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'date',
    align: 'left',
    minWidth: 125,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Schedule Type',
    accessor: 'schedulingType',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Submitted By',
    accessor: 'submittedBy',
    align: 'left',
    minWidth: 225,
    sortable: true,
  },
  {
    title: 'Submit Status',
    accessor: 'submitStatus',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Bid ID',
    accessor: 'bidId',
    align: 'left',
    minWidth: 150,
    sortable: true,
  },
  {
    title: 'MRID',
    accessor: 'mrid',
    align: 'left',
    minWidth: 400,
    sortable: true,
  },
  {
    title: 'Message',
    accessor: 'message',
    align: 'left',
    minWidth: 200,
  },
  {
    title: 'Block',
    accessor: 'block',
    align: 'right',
  },
  {
    title: 'Hour End',
    accessor: 'interval',
    align: 'right',
  },
  {
    title: 'Load',
    accessor: 'load',
    align: 'right',
  },
  {
    title: 'Price',
    accessor: 'price',
    align: 'right',
  },
  {
    title: 'Submit Type',
    accessor: 'submitType',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Curve Type',
    accessor: 'curveType',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Submission ID',
    accessor: 'submissionId',
    align: 'left',
    minWidth: 200,
    sortable: true,
  },
]

export function getSubmissionHistoryTableSchemaByMarket(
  market: string,
  schedulingType: LsSchedulingType | undefined,
): GenericTableColumn[] {
  if (market === 'ERCOT' && schedulingType === 'DEMAND_SCHEDULING') {
    return ercotTableSchema
  }

  return defaultTableSchema
}

export function getLoadSchedulingSubmissionsSchema(): Column[] {
  return [
    {
      title: 'Market',
      accessor: 'market',
      align: 'left',
      sortable: true,
    },
    {
      title: 'Brand',
      accessor: 'brand',
      align: 'left',
      sortable: true,
    },
    {
      title: 'Zone',
      accessor: 'zone',
      align: 'left',
      sortable: true,
    },
    {
      title: 'Location',
      accessor: 'location',
      align: 'left',
      sortable: true,
    },
    {
      title: 'Submitted Date',
      accessor: 'submittedDate',
      align: 'left',
      minWidth: 225,
      sortable: true,
    },
    {
      title: 'Start Flow Dates',
      accessor: 'startFlowDate',
      align: 'left',
    },
    {
      title: 'End Flow Dates',
      accessor: 'endFlowDate',
      align: 'left',
    },
    {
      title: 'Schedule Type',
      accessor: 'schedulingType',
      align: 'left',
      minWidth: 30,
      sortable: true,
    },
    {
      title: 'Status',
      accessor: 'latestSubmissionStatus',
      align: 'center',
    },
    {
      title: 'Group Id',
      accessor: 'submissionGroupId',
      align: 'left',
      minWidth: 200,
    },
    {
      title: 'Download',
      accessor: 'download',
      align: 'center',
    },
    {
      title: 'View More',
      accessor: 'viewMore',
      align: 'center',
    },
  ]
}

export const lsSubmissionSummaryTableSchema = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
  },
  {
    title: 'Flow Dates',
    accessor: 'dateRange',
    align: 'left',
  },
  {
    title: 'Status',
    accessor: 'status',
    align: 'left',
    disableToggle: true,
  },
] as GenericTableColumn[]

export function getLSClearedBidsTableSchema(): Column[] {
  return [
    {
      title: 'date',
      accessor: 'date',
      align: 'left',
      pinnable: true,
      sticky: 'left',
      minWidth: 125,
    },
    {
      title: 'market',
      accessor: 'market',
      align: 'left',
    },
    {
      title: 'brand',
      accessor: 'brand',
      align: 'left',
      minWidth: 125,
    },
    {
      title: 'zone',
      accessor: 'zone',
      align: 'left',
    },
    {
      title: 'location',
      accessor: 'location',
      minWidth: 200,
    },
    {
      title: 'location name',
      accessor: 'locationName',
    },
    {
      title: 'submit type',
      accessor: 'submitType',
      minWidth: 200,
    },
    ...Array.from({ length: 24 }, (_, i) => ({
      title: `${i + 1}`,
      accessor: `${i + 1}`,
      align: 'right',
    })),
  ]
}

export const lsSubmissionPreviewTableColumns = [
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    pinnable: true,
    sticky: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location Name',
    accessor: 'location_name',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Date',
    accessor: 'date',
    align: 'left',
    sortable: true,
    filterType: 'datetime',
  },
  ...Array.from({ length: 24 }, (_, i) => ({
    title: `${i + 1}`,
    accessor: `${i + 1}`,
    align: 'right',
    filterType: 'number',
  })),
] as GenericTableColumn[]

export const lsErcotSubmissionPreviewTableColumns = [
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    pinnable: true,
    sticky: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location Name',
    accessor: 'location_name',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Date',
    accessor: 'date',
    align: 'left',
    sortable: true,
    filterType: 'datetime',
  },
  {
    title: 'Block',
    accessor: 'block',
    align: 'right',
  },
  {
    title: 'Interval',
    accessor: 'interval',
    align: 'right',
  },
  {
    title: 'Load',
    accessor: 'load',
    align: 'right',
  },
  {
    title: 'Supply',
    accessor: 'supply',
    align: 'right',
  },
  {
    title: 'Open Position',
    accessor: 'open_position',
    align: 'right',
  },
  {
    title: 'NOP',
    accessor: 'net_open_position',
    align: 'right',
  },
  {
    title: 'Demand',
    accessor: 'demand',
    align: 'right',
  },
  {
    title: 'Price',
    accessor: 'price',
    align: 'right',
  },
  {
    title: 'Bid or Offer',
    accessor: 'bid_or_offer',
    align: 'right',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Curve Type',
    accessor: 'curve',
    align: 'right',
    sortable: true,
    filterType: 'string',
  },
] as GenericTableColumn[]

export const lsInternalBilateralTableSchema = [
  {
    title: 'contract id',
    accessor: 'contract_id',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Contract Name',
    accessor: 'contract_name',
    align: 'left',
    minWidth: 200,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'brand',
    accessor: 'brand',
    align: 'left',
    pinnable: true,
    sticky: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'date',
    accessor: 'date',
    align: 'left',
    minWidth: 125,
    sortable: true,
    filterType: 'datetime',
  },
  {
    title: 'buyer',
    accessor: 'buyer',
    align: 'left',
    minWidth: 200,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Buyer QSE Code',
    accessor: 'buyer_qse_code',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'seller',
    accessor: 'seller',
    align: 'left',
    minWidth: 200,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Seller QSE Code',
    accessor: 'seller_qse_code',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  ...Array.from({ length: 24 }, (_, i) => ({
    title: `${i + 1}`,
    accessor: `${i + 1}`,
    align: 'right',
    filterType: 'number',
  })),
] as GenericTableColumn[]

export const lsClearedBidsTableSchema = [
  {
    title: 'Flow Date',
    accessor: 'date',
    align: 'left',
    pinnable: true,
    sticky: 'left',
    sortable: true,
    minWidth: 125,
    filterType: 'datetime',
  },
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
    filterType: 'string',
    minWidth: 125,
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location Name',
    accessor: 'locationName',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location',
    accessor: 'location',
    minWidth: 200,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Submit Type',
    accessor: 'submitType',
    minWidth: 200,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Hour',
    accessor: 'hour',
    sortable: true,
  },
  {
    title: 'Load',
    accessor: 'load',
    sortable: true,
  },
  {
    title: 'Price',
    accessor: 'price',
    sortable: true,
  },
] as GenericTableColumn[]
